import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { loggedInUser } from '@mobile/services/user';
import locale_de from './translations/de.json';
import locale_es from './translations/es.json';
import locale_fr from './translations/fr.json';
import locale_nl from './translations/nl.json';
import locale_pt_BR from './translations/pt-BR.json';
import { eventBus } from '@/eventBus';

Vue.use(VueI18n);

const scorePercentage = {
    style: 'percent',
    maximumFractionDigits: 2,
};

const analyticsPercentage = {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const analyticsInteger = {
    style: 'decimal',
    maximumFractionDigits: 0,
};

const analyticsFloat = {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const metricTemperature = {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const metricHumidity = {
    style: 'percent',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
};

const numberFormatters = {
    scorePercentage, analyticsPercentage, analyticsInteger, analyticsFloat, metricTemperature, metricHumidity,
};

const numberFormats = {
    en: numberFormatters,
    de: numberFormatters,
    nl: numberFormatters,
    es: numberFormatters,
    fr: numberFormatters,
    'pt-BR': numberFormatters,
};

const longDateTime = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
};

const shortDateTime = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

const shortDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
};

const shortDateOfYear = {
    month: 'short',
    day: 'numeric',
};

const time = {
    hour: 'numeric',
    minute: 'numeric',
};

const dateTimeFormatters = {
    time, shortDate, shortDateTime, longDateTime, shortDateOfYear,
};

const dateTimeFormats = {
    en: dateTimeFormatters,
    de: dateTimeFormatters,
    nl: dateTimeFormatters,
    es: dateTimeFormatters,
    fr: dateTimeFormatters,
    'pt-BR': dateTimeFormatters,
};

const defaultLocale = 'en';

export let i18n;

export default function create() {
    const user = loggedInUser();
    const locale = (user && user.locale) ? user.locale : defaultLocale;
    document.documentElement.setAttribute('lang', locale);

    i18n = new VueI18n({
        locale,
        silentFallbackWarn: true,
        silentTranslationWarn: true,
        formatFallbackMessages: true,
        numberFormats,
        dateTimeFormats,
        messages: {
            de: locale_de,
            es: locale_es,
            fr: locale_fr,
            nl: locale_nl,
            'pt-BR': locale_pt_BR,
        },
    });

    eventBus.$on('login', (user) => {
        i18n.locale = user.locale ? user.locale : defaultLocale;
        document.documentElement.setAttribute('lang', i18n.locale);
    });

    eventBus.$on('logout', () => {
        i18n.locale = defaultLocale;
        document.documentElement.setAttribute('lang', i18n.locale);
    });

    return i18n;
}
